import { FC, useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { LeftOutlined, RightOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PopupField from './PopupField';
import { displayNumber } from '../utils/formatters';

interface ParcellePopupProps {
  transactions: any[];
  parcelleStats: any;
}

const ParcellePopup: FC<ParcellePopupProps> = ({
  transactions,
  parcelleStats,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const transaction = transactions[selectedIndex];

  useEffect(() => setSelectedIndex(0), [transactions, setSelectedIndex]);

  return (
    transaction && (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "white",
            padding: 16,
            borderRadius: 8,
            width: 340,
            boxShadow:
              "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
          }}
        >
          <header
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 12,
            }}
          >
            <div
              style={{
                textTransform: "uppercase",
                fontWeight: "bolder",
                fontSize: 14,
                marginBottom: 4,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>{`${transaction.Adresse}, ${transaction.NPA} ${transaction.CommuneAdresse}`}</span>
              <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: 12,
                  backgroundColor: transaction.SVB_Verifiee ? "green" : "red",
                }}
              ></div>
            </div>
            <span style={{ marginBottom: 4, fontSize: 11 }}>
              {transaction.Usages}
            </span>
          </header>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", marginBottom: 8 }}>
              <div
                style={{
                  display: "flex",
                  width: "50%",
                  borderRight: "1px solid #e0e0e0",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  fontSize: 11,
                }}
              >
                <span style={{ textTransform: "uppercase" }}>Détails</span>

                <PopupField
                  label="Année de la transaction"
                  value={transaction.Year}
                />

                <PopupField
                  label="Prix CHF"
                  value={displayNumber(transaction.Prix)}
                />

                {transaction.SVB_Verifiee && (
                  <PopupField
                    label="m²"
                    value={displayNumber(
                      transaction.SVB_Verifiee || transaction.SVB_Estimee
                    )}
                  />
                )}

                {transaction.SVB_Verifiee && (
                  <PopupField
                    label="Prix/m² CHF"
                    value={displayNumber(transaction.Prix_m2_habitable)}
                  />
                )}

                <PopupField
                  label="Année de construction"
                  value={transaction.AnneeConstruction}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  width: "50%",
                  justifyContent: "center",
                  flexDirection: "column",
                  fontSize: 11,
                  paddingLeft: 8,
                }}
              >
                <span style={{ textTransform: "uppercase" }}>
                  Donnée de la zone &nbsp; &nbsp;
                  <Tooltip
                    title={
                      <span style={{ fontSize: 9, lineHeight: 0.75 }}>
                        Données sur 1km², basées sur les filtres
                      </span>
                    }
                    overlayInnerStyle={{ padding: "0 8px", minHeight: 26 }}
                  >
                    <span>
                      <InfoCircleOutlined />
                    </span>
                  </Tooltip>
                </span>

                <PopupField
                  label="Valeur médiane m2"
                  value={displayNumber(parcelleStats?.median_prix_m2_habitable)}
                />

                <PopupField
                  label="Valeur médiane CHF"
                  value={displayNumber(parcelleStats?.median_prix)}
                />

                <PopupField
                  label="Valeur haute CHF"
                  value={displayNumber(parcelleStats?.highest_price)}
                />

                <PopupField
                  label="Nombre de transactions"
                  value={displayNumber(parcelleStats?.nb_transactions)}
                />

                <PopupField
                  label="Volume CHF"
                  value={displayNumber(parcelleStats?.volume)}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <a
              onClick={(event) => {
                event.stopPropagation();
                window.open(
                  `https://melcarne.digipulse.ch/collections/transactions_fao?id=${transaction.id}`,
                  "_blank"
                );
              }}
              style={{ textDecoration: "underline", fontSize: 12 }}
              href="#"
            >
              Voir les détails
            </a>
          </div>

          {transactions.length > 1 && (
            <div
              style={{
                marginTop: 8,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                type="link"
                size="small"
                icon={<LeftOutlined />}
                onClick={() => {
                  if (selectedIndex > 0) setSelectedIndex(selectedIndex - 1);
                }}
              ></Button>
              <span style={{ fontSize: 12, margin: "0 4px" }}>{`${
                selectedIndex + 1
              } / ${transactions.length}`}</span>
              <Button
                type="link"
                size="small"
                icon={<RightOutlined />}
                onClick={() => {
                  if (selectedIndex < transactions.length - 1)
                    setSelectedIndex(selectedIndex + 1);
                }}
              ></Button>
            </div>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            width: 12,
            height: 12,
            backgroundColor: "white",
            transform: "rotate(45deg)",
            bottom: 12,
            left: "calc(50% - 8px)",
          }}
        ></div>
      </>
    )
  );
};

export default ParcellePopup;
